//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Toast } from 'vant'
import { GetMeridiansListService, MeridiansInfoService, BodyList, BodyInfo, AcupointList } from '@/api/index'
export default{
  data () {
    return {
      baseUrl: this.global.baseUrl,
      value: '',
      active: 0,
      desc: '经络包含穴位',
      selectFlag: false,
      acupointList: [],
      meridian: {},
      meridians: []
    }
  },
  created () {
    this.init()
  },
  methods: {
    changeInfo () {
      if (this.value === '') {
        this.selectFlag = false
      } else {
        AcupointList({name: this.value}).then(resp => {
          if(resp.data){
            this.selectFlag = resp.data.length !== 0
            this.acupointList = resp.data
          }else{
            this.selectFlag = false
          }
        }).catch(error => {
          this.selectFlag = false
          Toast(error.message)
        })
      }
    },
    onChange (tab) {
      this.active = tab
      if (tab === 0) {
        this.desc = '经络包含穴位'
        this.init()
      } else {
        this.desc = '部位包含穴位'
        this.bodyList()
      }
    },
    lookInfo (id) {
      if (!id) {
        Toast('数据不存在')
        return
      }
      if (this.active === 0) {
        MeridiansInfoService({id: id}).then(res => {
          this.meridian = res.data
        }).catch(error => {
          Toast(error.message)
        })
      } else {
        BodyInfo({id: id}).then(res => {
          this.meridian = res.data
        }).catch(error => {
          Toast(error.message)
        })
      }
    },
    bodyList () {
      BodyList().then(resp => {
        this.meridians = resp.data
        if (this.meridians.length > 0) {
          BodyInfo({id: this.meridians[0].id}).then(res => {
            this.meridian = res.data
          }).catch(error => {
            Toast(error.message)
          })
        }
      }).catch(error => {
        Toast(error.message)
      })
    },
    init () {
      GetMeridiansListService().then(resp => {
        this.meridians = resp.data
        if (this.meridians.length > 0) {
          MeridiansInfoService({id: this.meridians[0].id}).then(res => {
            this.meridian = res.data
          }).catch(error => {
            Toast(error.message)
          })
        }
      }).catch(error => {
        Toast(error.message)
      })
    },
    acupointInfo (id) {
      if (!id) {
        Toast('数据不存在')
        return
      }
      this.$router.push({
        path: '/acupoint-info1',
        query: {
          id: id
        }
      })
    },
    reback () {
      this.$router.push({
        path: '/'
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/acupoint.vue